import { render, staticRenderFns } from "./m-video-player.vue?vue&type=template&id=58230386&scoped=true"
import script from "./m-video-player.vue?vue&type=script&lang=js"
export * from "./m-video-player.vue?vue&type=script&lang=js"
import style0 from "./m-video-player.vue?vue&type=style&index=0&id=58230386&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58230386",
  null
  
)

export default component.exports